import { render, staticRenderFns } from "./licensese.vue?vue&type=template&id=100a222e&scoped=true&"
import script from "./licensese.vue?vue&type=script&lang=js&"
export * from "./licensese.vue?vue&type=script&lang=js&"
import style0 from "./licensese.vue?vue&type=style&index=0&id=100a222e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100a222e",
  null
  
)

export default component.exports